import { isGlobalworth, paths } from 'config'
import { Loadable } from 'shared/components'
import { ModuleRoute } from 'shared/types'
import { DrawerNewsfeed, Newsfeed } from 'shared/assets'

const routes: ModuleRoute[] = [
  {
    path: paths.news,
    admin: false,
    exact: true,
    linkSettings: {
      icon: isGlobalworth ? Newsfeed : DrawerNewsfeed,
      label: 'nav.news',
    },
    component: Loadable({
      component: () => import('./pages/Newsfeed'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.addNewsfeedNotification,
    admin: false,
    exact: true,
    component: Loadable({
      component: () => import('./pages/AddNotification'),
    }),
    layoutSettings: {},
  },
]

export default routes
